const env = {
  dev: {
    apiUrl: "https://prod.getnarrativeapp.com/api/",
    publicUrl: "http://localhost:4000/admin/"
  },
  prod: {
    apiUrl: "https://service.getnarrativeapp.com/api/",
    publicUrl: "https://service.getnarrativeapp.com/"
  }
};

const stage =
  process.env.REACT_APP_STAGE === undefined
    ? "dev"
    : process.env.REACT_APP_STAGE;

export const config = {
  ...env[stage]
};
